class APIS {
    apis() {
        return {
            fetch: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/client/webhooks',
            },
            fetchEventTypes: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/get/webhook/event/types',
            },
            add: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/create/client/webhook',
            },
            update: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/update/client/webhook',
            },
            getWebhookLogs: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/webhook-logs',
            },
        };
    }
}

export default new APIS();
